module.exports = __webpack_public_path__ + "img/activeallocate.d7f9eefb.svg";